import Flickity from 'flickity';
import { gsap, Observer, ScrollTrigger } from "../global/gsap";

const initHomeCourses = (homeCourses) => {
    // carousel set up
    const carousel = homeCourses.querySelector('.js-courses-carousel');

    const flickityOptions = {
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        cellSelector: '.js-course-slide',
    };

    const flkty = new Flickity(carousel, flickityOptions);

    const carouselPrev = document.querySelector(".js-course-carousel-prev");
    const carouselNext = document.querySelector(".js-course-carousel-next");

    if (carouselPrev) {
        carouselPrev.addEventListener("click", () => {
            flkty.previous();
        });
    }

    if (carouselNext) {
        carouselNext.addEventListener("click", () => {
            flkty.next();
        });
    }
};

export { initHomeCourses as default };
